import { JsonObject, JsonProperty } from "json2typescript"

//** Model spoje pro mapu * /
@JsonObject("Connection")
export class Connection {
  @JsonProperty('sourceType', String)
  sourceType: string = '' //** S - autobus/tramvaj/trolejbus (MHD, VLD), K - vlak */

  @JsonProperty('id', String)
  id: string = ''

  @JsonProperty('dep', String)
  dep: string = ''

  @JsonProperty('dest', String)
  dest: string = ''

  @JsonProperty('depTime', String)
  depTime: string = ''

  @JsonProperty('destTime', String)
  destTime: string = ''

  @JsonProperty('name', String)
  name: string = ''

  @JsonProperty('vehicleType', String)
  vehicleType: string = '' // převzatá z JDF

  @JsonProperty('time', String)
  time: string = '' // čas údajů

  @JsonProperty('lat', Number)
  lat: number = 0

  @JsonProperty('lon', Number)
  lon: number = 0

  @JsonProperty('operator', String)
  operator: string = ''

  @JsonProperty('angle', Number, true)
  angle?: number = undefined

  @JsonProperty('lineNumber', Number, true)
  lineNumber?: number = undefined

  @JsonProperty('extLineName', String, true)
  extLineName?: string = undefined

  @JsonProperty('serviceNumber', Number, true)
  serviceNumber?: number = undefined

  @JsonProperty('isDetour', Boolean, true)
  isDetour?: boolean = undefined

  @JsonProperty('lineType', String, true)
  lineType?: string = undefined   // typ autobusové linky: V A Z D

  @JsonProperty('delay', Number, true)
  delay?: number = undefined

  @JsonProperty('desc', String, true)
  desc?: string = undefined

  @JsonProperty('passengerCount', Number, true)
  passengerCount?: number = undefined

  private prefName: string = '';
  private detailName: string = '';

  init(obj: Connection) {
    obj && Object.assign(this, obj);
  }

  detailedName() {
    if (!this.detailName) {
      if (this.sourceType == 'K')
        this.detailName = this.prefferedName();
      else if (this.extLineName) {
        const parts = this.name.split(" ");
        const name = parts.length > 1 ? `${parts[0]}/${parts[1]}` : parts[0];
        this.detailName = `${this.prefferedName()} (${name})`;
      }
      else
        this.detailName = this.name.replace(' ', '/');
    }      

    return this.detailName;
  }

  prefferedName(isForMap: boolean = true): string {
    if (!this.prefName) {
      if (this.sourceType == 'K') {
        this.prefName = this.name;
        if (isForMap && this.extLineName)
          return this.name; // api už nám poslalo kombinovaný název v name
      }
      else if (this.extLineName)
        this.prefName = this.extLineName;
      else {
        this.prefName = this.name.replace(' ', '/'); // bez oběhu
      }
    }

    return this.prefName;
  }
}
